import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useContext, useEffect } from "react";
import { ClaimContext } from "../../context/claimContext/ClaimContext";
import { getClaims } from "../../context/claimContext/ClaimApiCalls";
import LaunchIcon from "@mui/icons-material/Launch";
import Tooltip from "@mui/material/Tooltip";
import styled from "styled-components";

const Container = styled.div`
  flex: 4;
  height: 700px;
  padding: 20px;
`;

const Title = styled.h3`
  margin-bottom: 20px;
`;

const DataGridStyle = {
  padding: "20px",
  height: "100%",
  boxShadow: "0px 0px 15px -10px rgba(0, 0, 0, 0.75)",
};

const SearchInput = styled("input")({
  padding: "5px",
  marginBottom: "5px",
  fontSize: "16px",
  border: "none",
  borderBottom: "1px solid gray",
});

const Claims = () => {
  const { claims, dispatch } = useContext(ClaimContext);
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const columns = [
    { field: "caseNumber", headerName: "Claim Number", minWidth: 120, flex: 2 },
    {
      field: "orderNumber",
      headerName: "Aradas Order Number",
      minWidth: 170,
      flex: 2,
    },
    {
      field: "orderReference",
      headerName: "Reference",
      minWidth: 170,
      flex: 2,
    },
    {
      field: "createdDateUtc",
      headerName: "Created (UTC)",
      type: "dateTime",
      minWidth: 150,
      flex: 2,
    },
    { field: "status", headerName: "Status", minWidth: 150, flex: 2 },
    {
      field: "actions",
      headerName: "Open",
      type: "actions",
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Open">
              <LaunchIcon />
            </Tooltip>
          }
          label="Open"
          onClick={openClaim(params.id)}
        />,
      ],
    },
  ];

  const openClaim = useCallback(
    (id) => () => {
      navigate("/claims/" + id);
    },
    [navigate]
  );

  useEffect(() => {
    getClaims(dispatch);
  }, [dispatch]);

  const search = (data) => {
    return data.filter(
      (item) =>
        item.caseNumber.toLowerCase().includes(query) ||
        item.orderNumber.toLowerCase().includes(query) ||
        item.orderReference.toLowerCase().includes(query) ||
        item.createdDateUtc.toLowerCase().includes(query) || 
        item.status.toLowerCase().includes(query)
    );
  };

  return (
    <Container>
      <Title>Claims</Title>
      <SearchInput
        type="text"
        placeholder="search..."
        onChange={(e) => setQuery(e.target.value.toLowerCase())}
      />
      <DataGrid
        style={DataGridStyle}
        rows={search(claims)}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50, 100]}
        disableSelectionOnClick
      />
    </Container>
  );
};

export default Claims;
